export const SETUP_STEPS = ['Tu carta', 'Revisar platos', 'Canales de venta', 'Revision final'];
export const SETUP_HELP_EVENT = 'mozzoapp:setup-help';
export const SETUP_HELP = [
  'Quiero importar mi carta desde una imagen o PDF. Explicame como revisarla antes de crear platos ocultos.',
  'Como reviso nombres, precios, presentaciones y disponibilidad de mis platos en Carta?',
  'Como preparo salon con QR o delivery y retiro? Que debo revisar antes de habilitar las ventas?',
  'Que debo comprobar antes de publicar mi carta? Explicame tambien como continuar con ingredientes y stock.',
];

export function canPrepareRestaurant(access, environment) {
  return Boolean(['local', 'beta', 'production'].includes(environment) && access.isSupabaseConfigured && !access.isCreatorMode &&
    access.user?.id && access.currentCompany?.id && (access.currentBranch || access.currentRestaurant)?.id &&
    access.canAccessModule('menu') && access.canAccessModule('configuracion') &&
    access.canPerformAction('manage_menu') && access.canPerformAction('manage_settings'));
}

export const setupStorageKey = (environment, userId, companyId, branchId) =>
  `mozzoapp:restaurant-setup:v1:${environment}:${userId}:${companyId}:${branchId}`;

export function readSetupProgress(key) {
  try {
    const value = JSON.parse(localStorage.getItem(key) || 'null');
    return {
      started: value?.started === true,
      step: Number.isInteger(value?.step) && value.step >= 0 && value.step < 4 ? value.step : 0,
      review: typeof value?.review === 'string' ? value.review : '',
      channels: typeof value?.channels === 'string' ? value.channels : '',
      finished: typeof value?.finished === 'string' ? value.finished : '',
    };
  } catch { return { started: false, step: 0, review: '', channels: '', finished: '' }; }
}

export function writeSetupProgress(key, value) {
  try { localStorage.setItem(key, JSON.stringify(value)); return true; } catch { return false; }
}

// Compact change detector only; it is never used as an authorization or integrity token.
const fingerprint = (value) => {
  const text = JSON.stringify(value);
  let a = 2166136261, b = 5381;
  for (let i = 0; i < text.length; i += 1) {
    a = Math.imul(a ^ text.charCodeAt(i), 16777619);
    b = Math.imul(b, 33) ^ text.charCodeAt(i);
  }
  return `${text.length}:${a >>> 0}:${b >>> 0}`;
};

// Review acknowledgements are invalidated when the actual catalog or channels change.
// These are UI acknowledgements, never evidence of payment, permissions or publication.
export function setupFacts(snapshot) {
  const products = snapshot.products || [];
  const review = fingerprint([snapshot.menuId, [...products].sort((a, b) => a.id.localeCompare(b.id)), snapshot.categories, snapshot.subcategories]);
  const channels = fingerprint(snapshot.settings ?? null);
  return {
    review, channels, final: JSON.stringify([review, channels]),
    count: products.length,
    visible: products.filter((p) => p.active && p.visibleInMenu).length,
    hidden: products.filter((p) => !p.visibleInMenu).length,
    paused: products.filter((p) => !p.active).length,
  };
}

export function completedSetupSteps(snapshot, progress) {
  if (!snapshot) return [false, false, false, false];
  const facts = setupFacts(snapshot);
  const imported = facts.count > 0;
  const reviewed = imported && progress.review === facts.review;
  const channels = reviewed && Boolean(snapshot.settings) && progress.channels === facts.channels;
  return [imported, reviewed, channels, channels && progress.finished === facts.final];
}
